import React from 'react';
import { IconFill, IconProps } from './IconTemplate';

import { ReactComponent as Icon } from '@assets/icons/arrow-back.svg';

export default function ArrowBackIcon(props: IconProps) {
  return <IconFill icon={Icon} {...props} />;
}
